<ion-header><app-navheader></app-navheader></ion-header>
<ion-content padding style="background-color: #f4f4f4;">
<div class="books-header"><span class="subheader-row1">Actu Livres</span><span [ngClass] = "{'mquo': themeClass === 'mquo', 'lepq': themeClass === 'lepq', 'actu': themeClass === 'actu'}" class="subheader-row2">PARTENARIAT</span></div>
<!-- <div class="overlay" [hidden] = "!search"></div> -->

  <ion-card *ngFor="let book of books">
      <ion-grid>
        <ion-row>
          <ion-col col-6>
            <div id="card-logo">
              <img *ngIf = "book.book_edition_image" src="{{book.book_edition_image.url}}"/>
            </div>
          </ion-col>
           <ion-col col-6 style="text-align: right;">
           <div id="card-pubdate"></div>
          </ion-col>
        </ion-row>
      </ion-grid>
  <div class="rule-logo"></div>
  <ion-card-content>
    <div [ngClass]= "{'article-detail-category-title-container': true, 'mquo': book.book_newspaper === 'mquo', 'lepq': book.book_newspaper === 'lepq', 'actu': book.book_newspaper === 'actu', 'aeco': book.book_newspaper === 'aeco', 'mlwk': book.book_newspaper === 'mlwk', 'mlne': book.book_newspaper === 'mlne', 'week': book.book_newspaper === 'week', 'mwne': book.book_newspaper === 'mwne', 'woch': book.book_newspaper === 'woch', 'sema': book.book_newspaper === 'sema'}">

      <div class="clear"></div>
      <h2 (click)="navigateToDetail(book)">
        {{book.book_title}}
      </h2>
    </div>
    <span class="author" *ngIf="book.book_author" [innerHTML]= "book.book_author"></span>
    <div class="article-list-image" (click)="navigateToDetail(book)" [ngClass]= "{'lepq': book.book_newspaper === 'lepq', 'mquo': book.book_newspaper === 'mquo',
     'actu': book.book_newspaper === 'actu'}" *ngIf="book.book_cover"><img class="book-cover" src="{{book.book_cover.url}}">
     <span class="copyright" *ngIf="book.book_eliseuse_url" (click) = "goToExtract(book.book_eliseuse_url, book.book_title)">Lire un extrait
    </span>
    </div>
      <div *ngIf="!book.book_header_color" class="article-content" [innerHTML]="book.book_description | slice:0:175 | texttrim | safeHtml"></div>
        <span class="readmore" (click)="navigateToDetail(book)">
          <span class="read-more"><ion-icon class="read-article"></ion-icon> Lire plus</span>
        </span>
    </ion-card-content>

    <ion-row>
      <ion-col class="home-card-sides">
          <div class="card-footer">
            <app-partager-button [include] = "getInclude(book)" [title]="book.book_title" url="/actu-livres/{{book.book_slug}}">
              <ion-icon class="share-timeline"></ion-icon>
              <span class="card-footer-text">PARTAGER</span>
            </app-partager-button>
          </div>
      </ion-col>
      <ion-col class="home-card-middle">
          <div class="card-footer">
            <app-favorite-button [favorited]="book?.favorite || false" type="book" [id]="book.book_id">
              <div class="add">
                <ion-icon class="favoris-ajouter-plus"></ion-icon>
                <span class="card-footer-text">{{'TIMELINE.ARTICLE.BUTTONS.FAVORITE' | translate}}</span>
              </div>
              <div class="remove">
                <ion-icon class="favoris-suprimer-moins"></ion-icon>
                <span class="card-footer-text">{{'TIMELINE.ARTICLE.BUTTONS.FAVORITE_REMOVE' | translate}}</span>
              </div>
              <div class="noauth">
                <ion-icon class="favoris-ajouter-plus"></ion-icon>
                <span class="card-footer-text">{{'TIMELINE.ARTICLE.BUTTONS.FAVORITE' | translate}}</span>
              </div>
            </app-favorite-button>
          </div>
      </ion-col>
      <!-- <ion-col center text-center class="home-card-sides">
          <div class="card-footer">
          <ion-icon class="comment-timeline"></ion-icon>
            <span class="card-footer-text">COMMENTER</span>
          </div>
      </ion-col> -->
    </ion-row>
  </ion-card>
  <app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer>
  <app-bottom-menu [isActive] = "isActivePage"></app-bottom-menu>
</ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
